import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../api.service';
import {TaggedBaseComponent} from '../../tags/tagged-base/tagged-base.component';

@Component({
  selector: 'app-list-calendar',
  templateUrl: './list-calendar.component.html',
  styleUrls: ['./list-calendar.component.css']
})
export class ListCalendarComponent extends TaggedBaseComponent implements OnInit {
    selectedTags = [];
    public calendar: any;
    public loaded = false;
    protected today: Date;
    public availableTags: any;
    public filtered;
    public currentsorting: string;
    public sortingOrder;
    public repetitions = {'no': 'No', '1': 'Daily', '2': 'every second day', '3': 'weekly'};
    constructor(  private apiService: ApiService ) {
        super('calendar');
        this.sortingOrder = 'up';
        this.today = new Date();
        this.today.setHours(0, 0, 0);
    }

    ngOnInit() {
        this.getCalendar();
    }

    getCalendar() {
        this.apiService.getAll('calendar').subscribe(
            (value) => {
                this.loaded = true;
                this.calendar = value;
                this.calendar.map((calendar) => {
                    calendar.date = new Date(calendar.date);
                    calendar.daysUntil = this.daysUntil(calendar.date);
                    return calendar;
                });
                this.filtered = this.calendar;
            }
        );
    }

    deleteCalendar(id) {
        const confirmed = window.confirm('Are you sure?');
        if (confirmed) {
            this.apiService
                .deleteByID('calendar', id)
                .toPromise()
                .then(
                    () => {
                        this.getCalendar();
                    },
                    () => {
                        alert('deletion failed');
                    }
                );
        }
    }

    // calculates the amount of days between today and the event
    daysUntil(date: Date) {
        const theday = new Date(date);
        theday.setHours(0, 0, 0);
        const dateDiff = theday.getTime() - this.today.getTime();
        const daysDiff = Math.round(dateDiff / 1000 / 3600 / 24);
        return daysDiff;
    }

    sortBy(attribute: string) {
        if (attribute === this.currentsorting) {
            this.sortingOrder = this.sortingOrder === 'up' ? 'down' : 'up';
        } else {
            this.sortingOrder = 'up';
        }
        this.currentsorting = attribute;
        switch (attribute) {
            case 'calendar':
                this.filtered = this.filtered.sort((a, b) => {
                    const aDay = new Date(a.calendar);
                    const bDay = new Date(b.calendar);
                    aDay.setFullYear(0);
                    bDay.setFullYear(0);
                    if (this.sortingOrder === 'up') {
                        return aDay > bDay ? 1 : -1;
                    }
                    return bDay > aDay ? 1 : -1;
                });
                break;
            default:
                this.filtered.sort((a, b) => {
                    if (this.sortingOrder === 'up') {
                        return a[attribute] > b[attribute] ? 1 : -1;
                    }
                    return b[attribute] > a[attribute] ? 1 : -1;
                });
                break;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/calendar/list-calendar/list-calendar.component.ts